module.exports = __webpack_public_path__ + "static/media/QuietStandMale.0f89c8ec.svg";